import { patientSchema } from "./orders.schema";
import type { Patient } from "./orders.types";

export const isValidPatient = (patient: unknown): patient is Patient => {
  const res = patientSchema.safeParse(patient);
  return res.success;
};
